import { Link } from "react-router-dom";
import { getLatestArticles } from "@/mocks/articles";

export default function SEOArticlesSection() {
  const displayArticles = getLatestArticles(10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-6 md:px-10 max-w-7xl">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">
            SEO Guides &amp; Articles
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
          OOPBuy Spreadsheet
          <br />
          <span className="text-accent-500">Buying Guides &amp; Tutorials</span>
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl">
          In-depth articles to help you master spreadsheet-based product sourcing. From beginner guides to advanced strategies.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200 hover:border-accent-300 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                    {article.categoryLabel}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.intro}
                </p>
                <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
                  <span className="text-xs text-primary-600 font-medium group-hover:text-primary-700 transition-colors">
                    Read Article
                  </span>
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
                    <i className="ri-arrow-right-line text-xs text-foreground-600 group-hover:text-primary-600"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/what-is-oopbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}